module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": _vm.url,
      "httpOptions": _vm.options,
      "fields": _vm.fields,
      "pagination-path": ""
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vuetable-pagination ui basic segment grid"
  }, [_c('vuetable-pagination-info', {
    ref: "paginationInfo"
  }), _vm._v(" "), _c('bulma-pagination', {
    ref: "pagination",
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f514c4c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dothraki/PaymentsTable.vue
// module id = 254
// module chunks = 1